import React from 'react';

import { CircularProgress } from '@mui/material';

import { colors } from 'theme/colors';

import { Button } from 'components/Button';

export const SubmitButton: React.FC<{
  isSubmitting: boolean;
  isResetting: boolean;
  editView: boolean;
  disabled: boolean;
}> = ({ isResetting, isSubmitting, editView, disabled }) => (
  <Button
    id="create-field-button"
    variant="contained"
    size="large"
    type="submit"
    disabled={disabled || isSubmitting || isResetting}
    sx={{ marginLeft: '8px' }}
  >
    {isSubmitting && <CircularProgress color="inherit" size="16px" sx={{ marginRight: '8px' }} />}
    {editView ? 'Save' : 'Create'}
  </Button>
);

export const CancelButton: React.FC<{ handleClose: () => void; editView: boolean }> = ({ handleClose, editView }) => (
  <Button
    id="cancel-button"
    variant={editView ? 'outlined' : 'text'}
    size="large"
    onClick={handleClose}
    data-testid="cancelButton"
  >
    Cancel
  </Button>
);

export const ErrorMessage: React.FC<{ error: string }> = ({ error }) => (
  <p style={{ margin: 0, fontSize: '12px', color: colors.error.main }}>{error}</p>
);
